import React from 'react';
import * as css from './openInNewTab.module.scss';
import Icon, { IconType } from '../icon';
import { Link } from 'react-router-dom';
import classnames from 'classnames';

interface OpenInNewTabProps {
  to: string;
  label: string;
  title?: string;
  className?: string;
}

const OpenInNewTab: React.FC<React.PropsWithChildren<OpenInNewTabProps>> = ({
  to,
  label,
  title,
  className,
}) => (
  <Link to={to} target={'_blank'}>
    <div title={title} className={classnames(css.openInNewTab, className)}>
      {label}
      <Icon type={IconType.OpenInNew} />
    </div>
  </Link>
);

export default OpenInNewTab;
